import { ref } from 'vue';
import api from '@/api';

const data = ref();
const error = ref(null);

export default async function getTTS(text) {
  try {
    const ttsData = await api.tts.getTts(text);
    data.value = ttsData;
  } catch (err) {
    error.value = err;
  }

  return { data, error };
}
